import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const externalAccount = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/users/external-account/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const deletePaymentAccount = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/paymentMethod/delete/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const updateBuyerPaymentDetails = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/update/buyer/payment/details', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const updatePaymentDetails = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/subscriptions/update/payment/details', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const paymentMethod = (token) => (dispatch) => {
  return axioPath
    .get('/user/paymentMethod/list', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const defaultPayment = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/paymentMethod/make/default/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const paymentMethodCreate = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const paymentClientSecret = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/paymentMethod/clientSecret', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const verifyApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/achpayment/verify', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const orderHoldPayment = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/update/payment/order/hold', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const paymentMethodProfileCreate = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/independent/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const profileCreateBuyerSeller = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/buyer/seller/profile/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const subscriptionsCreate = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/subscriptions/create', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const subscriptionsAddNew = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/paymentMethod/subscriptions/add/new', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
